import { LAYOUT_ROUTE } from './../../../../../constants/routes.constants';

const PARENT_ROUTE = 'dashboard'


export const DASHBOARD_HOME_ROUTE = {
  path: 'home',
  halfUrlRoute: `/dashboard/home`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  },

};

export const DASHBOARD_PLACES_ROUTE = {
  path: 'places',
  halfUrlRoute: `/dashboard/places`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  },
};


export const DASHBOARD_EVENTS_ROUTE = {
  path: 'events',
  halfUrlRoute: `/dashboard/events`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}
// squawkpit

export const DASHBOARD_SQUAWKPIT_ROUTE = {
  path: 'forum',
  halfUrlRoute: `/dashboard/forum`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}

export const DASHBOARD_CATEGORIES_ROUTE = {
  path: 'categories',
  halfUrlRoute: `/dashboard/categories`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}

export const DASHBOARD_REVIEWS_ROUTE = {
  path: 'reviews',
  halfUrlRoute: '/dashboard/reviews',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}

export const DASHBOARD_BUSINESS_ROUTE = {
  path: 'business',
  halfUrlRoute: `/dashboard/business`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}

export const DASHBOARD_SETTINGS_ROUTE = {
  path: 'settings',
  halfUrlRoute: `/dashboard/settings`,
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}

export const DASHBOARD_CHAT_ROUTE = {
  path: 'chat',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}
export const DASHBOARD_COMETCHAT_ROUTE = {
  path: 'cometchat',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}
export const DASHBOARD_ADVERTISEMENT_ROUTE = {
  path: 'advertisement',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}


export const DASHBOARD_PROFILE_ROUTE = {
  path: 'profile',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}
export const DASHBOARD_COMMUNITY_GROUP_ROUTE = {
  path: 'community-groups',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}
export const DASHBOARD_QUIZ_EDIT_ROUTE = {
  path: 'quiz-edit',
  get url(): string {
    return `${LAYOUT_ROUTE.url}/${this.path}`
  }
}










export const DASHBOARD_ROUTE_CONSTANTS = {
  DASHBOARD_BUSINESS_ROUTE,
  DASHBOARD_REVIEWS_ROUTE,
  DASHBOARD_CATEGORIES_ROUTE,
  DASHBOARD_SQUAWKPIT_ROUTE,
  DASHBOARD_EVENTS_ROUTE,
  DASHBOARD_QUIZ_EDIT_ROUTE,
  DASHBOARD_PROFILE_ROUTE,
  DASHBOARD_COMMUNITY_GROUP_ROUTE,
  DASHBOARD_ADVERTISEMENT_ROUTE,
  DASHBOARD_SETTINGS_ROUTE,
  DASHBOARD_PLACES_ROUTE,
  DASHBOARD_HOME_ROUTE,
  DASHBOARD_CHAT_ROUTE,
  DASHBOARD_COMETCHAT_ROUTE
}
